import React from 'react'
import { EmptyState } from '@enamelai/design-system'
import './ProfileEmptyState.css'

type ProfileEmptyStateProps = {
  icon: React.FC<React.SVGProps<SVGSVGElement>>
  title: string
  description: string
  actionText?: string
  onAction?: () => void
  className?: string
}

function ProfileEmptyState({
  icon: IconComponent,
  title,
  description,
  actionText,
  onAction,
  className = '',
}: ProfileEmptyStateProps): React.ReactElement {
  return (
    <EmptyState
      className={`profile-empty-state ${className}`.trim()}
      illustration={<IconComponent aria-hidden />}
      title={title}
      description={description}
      actionLabel={onAction ? actionText : undefined}
      onAction={onAction}
    />
  )
}

export default ProfileEmptyState
